import React from 'react';
import ReactDOM from 'react-dom/client'
import HomeScreen from './Components/Screens/HomeScreen'
import './assets/css/sb-common.css'


const root = ReactDOM.createRoot(document.getElementById('sb-app'));
root.render(
    <React.StrictMode>
          <HomeScreen></HomeScreen>
    </React.StrictMode>
);